module.exports = "/_next/static/images/bj-9ec46b3a9a62cd0007c02123d7b2f953.svg";